
<div class="info-loading-overlay" *ngIf="infoLoading">
    <nz-spin nzSize="large" nzSimple></nz-spin>
    <p class="info-loading-text">{{'simpleform.loading.info'|translateTA}}</p>
</div>
<div class="main-content-edit" *ngIf="!loading">
    <editform 
        [removeReference]="removeReference"
        [parentRow]="parentRow"
        [entityName]="entityName"
        [row]="row"
        [filter]="filter"
        [userConfig]="userConfig"
        [tableInformation]="tableInformation"
        [formViewColumns]="formViewColumns"
        [formGroup]="formGroup"
        [evento]="evento"
        [$$REFERENCES]="$$REFERENCES"
        [actionList]="actionList"          
        (saving)="savingForm($event)"
        >
    </editform>
          
</div>